( function ($) {

	$( document ).ready( function() {
		/** subpages banner swiper slider **/
		var swiper = new Swiper('.__page_slider_banner', {
		    loop: true,
		    loopedSlides: 3,
		    spaceBetween: 0,
			speed: 1500,
			autoplay: {
				delay: 7000,
				disableOnInteraction: false,
			},
		 //    navigation: {
		 //        nextEl: '.swiper-btn-next',
		 //        prevEl: '.swiper-btn-prev',
   //    		},
			// pagination: {
			// 	el: '.swiper-pagination',
			// 	clickable: true,
			// },
		});

		
		/** header main menu superfish **/
	    $('ul#menu-main-menu').superfish({
	    	delay			: 300,
	    	animation		: {opacity:'show', height:'show'},
	    	animationOut	: {opacity:'hide'},
	    	speed			: 'fast'
	    });


		/** homepage what's on swiper slider **/
		var whatsonEventsSlider = new Swiper('.__whats_on_events_slider', {
			slidesPerView: 1,
		    spaceBetween: 11,
		    loop: true,
		    loopedSlides: 4,
		    speed: 500,
		    slideToClickedSlide: false,
			autoplay: {
				delay: 6000,
				disableOnInteraction: false,
			},
		    navigation: {
		        nextEl: '.swiper-btn-next',
		        prevEl: '.swiper-btn-prev',
      		},
			breakpoints: {
					// when window width is >= 512px
					512: {
					slidesPerView: 2,
					spaceBetween: 11
				},
					// when window width is >= 768px
					768: {
					slidesPerView: 2,
					spaceBetween: 11
				},
					// when window width is >= 1024px
					1024: {
					slidesPerView: 3,
					spaceBetween: 11
				},
					// when window width is >= 1200px
					1200: {
					slidesPerView: 4,
					spaceBetween: 11
				},
			}
		});


		/** autoheight homepage promotions title **/
		$( "main.home .promotions-section .promotion-title h2" ).autoHeight({
			'onResize': true,
		});

		$( ".events-list-section .event-details h2" ).autoHeight({
			'onResize': true,
		});

		$( ".events-list-section .event-details p" ).autoHeight({
			'onResize': true,
		});

		$( ".image-tiles-section .item-tile-content p" ).autoHeight({
			'onResize': true,
		});

		$( "main.home .whats-on-section .event-details h2" ).autoHeight({
			'onResize': true,
		});
	} );
	
	
	$( window ).resize( function() {
	    
	} );
	
	
	$( window ).load( function() {
	    
	} );
	
	
	$( document ).scroll( function() {

	} );

} ( jQuery ) );



/** moby mobile responsive menu **/
var $ = jQuery;

var mobyMenu = new Moby( {
	menu              : $( '#mobile-menu' ), // The menu that will be cloned
	mobyTrigger       : $( '#open-mobile-menu' ), // Button that will trigger the Moby menu to open
	menuClass		  : 'left-side',
	subMenuOpenIcon   : '<i class="fa fa-caret-down"></i>',
	subMenuCloseIcon  : '<i class="fa fa-caret-up"></i>',
	template          : '<div class="moby-close"><span class="moby-close-icon"></span></div><div class="moby-wrap"><div class="moby-menu"></div></div>'
} );
